// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0f093c59","239":"9d0994ac","455":"d1758fe4"}[chunkId] + ".chunk.js";
};